import { render, staticRenderFns } from "./PolicyAndTermsYdoc.vue?vue&type=template&id=2f1a7271&"
import script from "./PolicyAndTermsYdoc.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PolicyAndTermsYdoc.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1a7271')) {
      api.createRecord('2f1a7271', component.options)
    } else {
      api.reload('2f1a7271', component.options)
    }
    module.hot.accept("./PolicyAndTermsYdoc.vue?vue&type=template&id=2f1a7271&", function () {
      api.rerender('2f1a7271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/components/PolicyAndTermsYdoc.vue"
export default component.exports